import { render, staticRenderFns } from "./ServerBuilder.vue?vue&type=template&id=f6d5faa8"
import script from "./ServerBuilder.vue?vue&type=script&lang=js"
export * from "./ServerBuilder.vue?vue&type=script&lang=js"
import style0 from "./ServerBuilder.vue?vue&type=style&index=0&id=f6d5faa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports